import * as types from "../constants/ActionTypes";

const infosToSendToQuarentine = (state = [], action) => {
  switch (action.type) {
    case types.ADD_CONTACTIDS_TO_QUARENTINE:
      let hasThisContactIdInTheState = false;
      const newState = state.map((contactId) => {
        const hasThisId =
          parseInt(contactId.idatendimento) ===
            parseInt(action.contactId.idatendimento) &&
          parseInt(contactId.serviceatd) ===
            parseInt(action.contactId.serviceatd);
        if (hasThisId) {
          hasThisContactIdInTheState = true;
          return action.contactId;
        }
        return contactId;
      });
      if (!hasThisContactIdInTheState) {
        newState.unshift(action.contactId);
      }
      return newState;
    case types.REMOVE_CONTACTIDS_TO_QUARENTINE:
      const filteredState = state.filter((contactId) => {
        return (
          parseInt(contactId.idatendimento) !==
            parseInt(action.contactId.idatendimento) &&
          parseInt(contactId.serviceatd) !==
            parseInt(action.contactId.serviceatd)
        );
      });
      return filteredState;
    default:
      return state;
  }
};

export default infosToSendToQuarentine;
